// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_AQUARS = [{
  id: 'aquars_sea',
  factionId: FACTIONS.AQUARS,
  name: 'Страж пучины',
  priceNumens: 5000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.LIGHT_GREEN
  ]
}, {
  id: 'aquars_north',
  factionId: FACTIONS.AQUARS,
  name: 'Полярный ящер',
  priceNumens: 29000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.CELADON
  ]
}, {
  id: 'aquars_priestess',
  factionId: FACTIONS.AQUARS,
  name: 'Жрица глубин',
  priceNumens: 45000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'aquars_gold_legacy',
  factionId: FACTIONS.AQUARS,
  name: 'Речной налётчик',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'aquars_ruby_legacy',
  factionId: FACTIONS.AQUARS,
  name: 'Повелитель штормов',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
